import { createSlice } from "@reduxjs/toolkit";

const wishSlice = createSlice({
  name: "wishlist",
  initialState: {
    wishlist: [],
    error: null
  },
  reducers: {
    addProduct: (state, action) => {
      state.wishlist = [...state.wishlist, action.payload];
    },

    removeProduct: (state, action) => {
      state.wishlist = state.wishlist.filter(item => item.product.product_id !== action.payload.product_id);
    },

    clearWishlist: (state) => {
      state.wishlist = [];
    }
  }
});

export const { addProduct, removeProduct, clearWishlist } = wishSlice.actions;
export default wishSlice.reducer;
